module.exports = __webpack_public_path__ + "static/img/vip_icon_3.e50140e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member/vip_icon_3.png
// module id = 755
// module chunks = 1